import React from "react";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import PurchaseChannelField from "@quest_editor/components/QuestCondition/PurchaseChannelField";
import TargetStoreField from "@quest_editor/components/QuestCondition/TargetStoreField";
import TargetProductField from "@quest_editor/components/QuestCondition/TargetProductField";
import CategoryField from "@quest_editor/components/QuestCondition/CategoryField";
import ManufacturerField from "@quest_editor/components/QuestCondition/ManufacturerField";
import KeywordField from "@quest_editor/components/QuestCondition/KeywordField";
import {
  PurchaseChannel,
  Store,
  ProductWithManufacturer,
  Category as CategoryType,
  Manufacturer as ManufacturerType,
  Keyword as KeywordType,
} from "@quest_editor/mocks";

const PurchaseContentSection = ({
  purchaseChannels,
  purchaseChannelIds,
  setPurchaseChannelIds,
  targetStoreRows,
  setTargetStoreRows,
  targetProductRows,
  setTargetProductRows,
  categoryRows,
  setCategoryRows,
  manufacturerRows,
  setManufacturerRows,
  keywordRows,
  setKeywordRows,
}: {
  purchaseChannels: PurchaseChannel[];
  purchaseChannelIds: string[];
  setPurchaseChannelIds: React.Dispatch<React.SetStateAction<string[]>>;
  targetStoreRows: Store[];
  setTargetStoreRows: React.Dispatch<React.SetStateAction<Store[]>>;
  targetProductRows: ProductWithManufacturer[];
  setTargetProductRows: React.Dispatch<
    React.SetStateAction<ProductWithManufacturer[]>
  >;
  categoryRows: CategoryType[];
  setCategoryRows: React.Dispatch<React.SetStateAction<CategoryType[]>>;
  manufacturerRows: ManufacturerType[];
  setManufacturerRows: React.Dispatch<
    React.SetStateAction<ManufacturerType[]>
  >;
  keywordRows: KeywordType[];
  setKeywordRows: React.Dispatch<React.SetStateAction<KeywordType[]>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit_purchase.section.promotional_purchase")}
      rows={[
        {
          label: t(
            "quest_edit_purchase.field.content.by_purchase_channel.name",
          ),
          children: (
            <PurchaseChannelField
              purchaseChannels={purchaseChannels}
              purchaseChannelIds={purchaseChannelIds}
              setPurchaseChannelIds={setPurchaseChannelIds}
              emptyLabel={t(
                "quest_edit_purchase.label.not_specified.all_target",
              )}
            />
          ),
        },
        {
          label: t("quest_edit_purchase.field.content.by_target_store.name"),
          children: (
            <TargetStoreField
              targetStoreRows={targetStoreRows}
              setTargetStoreRows={setTargetStoreRows}
              emptyLabel={t(
                "quest_edit_purchase.label.not_specified.all_target",
              )}
            />
          ),
        },
        {
          label: t(
            "quest_edit_purchase.field.content.by_target_product.name",
          ),
          children: (
            <TargetProductField
              targetProductRows={targetProductRows}
              setTargetProductRows={setTargetProductRows}
              emptyLabel={t(
                "quest_edit_purchase.label.not_specified.all_target",
              )}
            />
          ),
        },
        {
          label: t("quest_edit_purchase.field.content.by_category.name"),
          children: (
            <CategoryField
              categoryRows={categoryRows}
              setCategoryRows={setCategoryRows}
              emptyLabel={t(
                "quest_edit_purchase.label.not_specified.all_target",
              )}
            />
          ),
        },
        {
          label: t("quest_edit_purchase.field.content.by_manufacturer.name"),
          children: (
            <ManufacturerField
              manufacturerRows={manufacturerRows}
              setManufacturerRows={setManufacturerRows}
              emptyLabel={t(
                "quest_edit_purchase.label.not_specified.all_target",
              )}
            />
          ),
        },
        {
          label: t("quest_edit_purchase.field.content.by_keyword.name"),
          children: (
            <KeywordField
              keywordRows={keywordRows}
              setKeywordRows={setKeywordRows}
              emptyLabel={t(
                "quest_edit_purchase.label.not_specified.none",
              )}
            />
          ),
        },
      ]}
    />
  );
};

export default PurchaseContentSection;
